export default __webpack_public_path__ + "static/media/Shroud of the Outer Dark.5a6ee4d3.jpg";